import { Routes } from '@angular/router';
import { RenderInterfaceGuard } from 'viggo-sistemas-core-web';

export const routesSysadminDefault: Routes = [
  {
    path: 'user',
    canActivate: [RenderInterfaceGuard],
    data: {
      preload: false,
      menuKey: 'SEGURANCA',
      breadcrumb: {
        label: 'Usuário',
        icon: 'pi pi-fw pi-user'
      },
      module: 'USER',
      backend_path: '/users'
    },
    loadChildren: () =>
      import('@app/modules/wrapperModules/user-wrapper/user-wrapper.module').then(
        m => m.UserWrapperModule
      )
  },
  {
    path: 'support-user',
    canActivate: [RenderInterfaceGuard],
    data: {
      preload: false,
      menuKey: 'SEGURANCA',
      breadcrumb: {
        label: 'Usuários por domínio',
        icon: 'pi pi-fw pi-users'
      },
      module: 'SUPORTE_USER',
      backend_path: '/users'
    },
    loadChildren: () =>
      import('@app/modules/wrapperModules/support-wrapper.module').then(
        m => m.SupportWrapperModule
      )
  },
  {
    path: 'application',
    canActivate: [RenderInterfaceGuard],
    data: {
      preload: false,
      menuKey: 'SYADMIN',
      breadcrumb: {
        icon: 'pi pi-fw pi-building',
        label: 'Aplicações'
      },
      module: 'APPLICATION',
      backend_path: '/applications',
      appConfig: {
        showButtonConfig: true,
        routerLinkConfig: 'edit_settings'
      }
    },
    loadChildren: () =>
      import('@app/modules/wrapperModules/application-wrapper.module').then(
        m => m.ApplicationWrappereModule
      )
  },
  {
    path: 'route',
    canActivate: [RenderInterfaceGuard],
    data: {
      preload: false,
      menuKey: 'SYSADMIN',
      breadcrumb: {
        icon: 'pi pi-fw pi-directions',
        label: 'Rotas'
      },
      module: 'ROUTE',
      backend_path: '/routes'
    },
    loadChildren: () =>
      import('@app/modules/wrapperModules/rota-wrapper.module').then(
        m => m.RouterWrapperModule
      )
  },
  {
    path: 'role',
    canActivate: [RenderInterfaceGuard],
    data: {
      preload: false,
      menuKey: 'SYSADMIN',
      breadcrumb: {
        icon: 'pi pi-fw pi-users',
        label: 'Papéis de usuário'
      },
      module: 'ROLE',
      backend_path: '/roles'
    },
    loadChildren: () =>
      import('@app/modules/wrapperModules/role-wrapper.module').then(
        m => m.RoleWrapperModule
      )
  },
  {
    path: 'domain',
    canActivate: [RenderInterfaceGuard],
    data: {
      preload: false,
      menuKey: 'SYSADMIN',
      breadcrumb: {
        icon: 'pi pi-fw pi-briefcase',
        label: 'Organização'
      },
      module: 'DOMAIN',
      backend_path: '/domains'
    },
    loadChildren: () =>
      import('@app/modules/wrapperModules/domain-wrapper/domain-wrapper.module').then(
        m => m.DomainWrapperModule
      )
  },
  {
    path: 'functionalities',
    canActivate: [RenderInterfaceGuard],
    data: {
      preload: false,
      menuKey: 'SYADMIN',
      breadcrumb: {
        icon: 'pi pi-fw pi-directions',
        label: 'Funcionalidades'
      },
      module: 'FUNCTIONALITY',
      backend_path: '/functionalities'
    },
    loadChildren: () =>
      import('@app/modules/wrapperModules/functionality-wrapper.module').then(
        m => m.FunctionalityWrapperModule
      )
  },
  {
    path: 'modules',
    canActivate: [RenderInterfaceGuard],
    data: {
      preload: false,
      menuKey: 'SYADMIN',
      breadcrumb: {
        icon: 'pi pi-fw pi-briefcase',
        label: 'Módulos'
      },
      module: 'MODULES',
      backend_path: '/modules'
    },
    loadChildren: () =>
      import('@app/modules/wrapperModules/modules-wrapper.module').then(
        m => m.ModulesWrapperModule
      )
  }
];
